import Icon from '../Icon';
import React from 'react';

const QuickSearchNoHit = (props) => {
  const { title, description } = props;

  return (
    <div className="flex items-center justify-center pt-6">
      <div className="flex flex-col items-center gap-2 text-center">
        <Icon name="emoji-dead" className="h-14 w-14" />
        {title && <h4>{title}</h4>}
        {description && (
          <div
            dangerouslySetInnerHTML={{
              __html: description.value,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default QuickSearchNoHit;
